import React from 'react'

const SearchAllUser = () => (
  <div>
    <input placeholder="검색"/>
  </div>

)
export default SearchAllUser



// WEBPACK FOOTER //
// ./src/CustomerLists/components/SearchAllUser.js